import { gsap } from "gsap";

(function ($) {
    let s = !1;
    function openMenu(){
        console.log('Open 3');
        window.addEventListener('elementor/popup/show', () => {
            console.log('Open 4');
            gsap.timeline({ onComplete: () => (s = !1) })
            .set('.popup-menu .elementor-widget-nav-menu li', { opacity: 0 })
            .set('.overlay-path', { attr: { d: "M 0 100 V 100 Q 50 100 100 100 V 100 z" } })
            .to('.overlay-path', { duration: 0.8, ease: "power4.in", attr: { d: "M 0 100 V 50 Q 50 0 100 50 V 100 z" } }, 0)
            .to('.overlay-path', {
                duration: 0.3,
                ease: "power2",
                attr: { d: "M 0 100 V 0 Q 50 0 100 0 V 100 z" },
                onComplete: () => {
                    jQuery('.popup-menu .dialog-widget-content').addClass("menu-open");
                },
            })
            .set('.popup-menu .elementor-widget-nav-menu li', { opacity: 0 })
            .set('.overlay-path', { attr: { d: "M 0 0 V 100 Q 50 100 100 100 V 0 z" } })
            .to('.overlay-path', { duration: 0.3, ease: "power2.in", attr: { d: "M 0 0 V 50 Q 50 0 100 50 V 0 z" } })
            .to('.overlay-path', { duration: 0.8, ease: "power4", attr: { d: "M 0 0 V 0 Q 50 0 100 0 V 0 z" } })
            .to('.popup-menu .elementor-widget-nav-menu li', { duration: 1.1, ease: "power4", startAt: { y: 150 }, y: 0, opacity: 1, stagger: 0.05 }, ">-=2")
        });
    }

    function closeMenu(){
        jQuery('body').removeClass("menu-open");
        console.log('Close 3');
        gsap.timeline({ onComplete: () => (s = !1) })
        .set('.overlay-path', { attr: { d: "M 0 0 V 0 Q 50 0 100 0 V 0 z" } })
        .to('.overlay-path', { duration: 0.8, ease: "power4.in", attr: { d: "M 0 0 V 50 Q 50 100 100 50 V 0 z" } }, 0)
        .to('.overlay-path', {
            duration: 0.3,
            ease: "power2",
            attr: { d: "M 0 0 V 100 Q 50 100 100 100 V 0 z" },
            onComplete: () => {
                jQuery('.popup-menu .dialog-widget-content').removeClass("menu-open");
                elementorFrontend.documentsManager.documents[2769].getModal().hide();
            },
        })
        .set('.overlay-path', { attr: { d: "M 0 100 V 0 Q 50 0 100 0 V 100 z" } })
        .to('.overlay-path', { duration: 0.3, ease: "power2.in", attr: { d: "M 0 100 V 50 Q 50 100 100 50 V 100 z" } })
        .to('.overlay-path', { duration: 0.8, ease: "power4", attr: { d: "M 0 100 V 100 Q 50 100 100 100 V 100 z" } })
        .to('.popup-menu .elementor-widget-nav-menu li', { duration: 0.8, ease: "power2.in", y: 100, opacity: 0, stagger: -0.05 }, 0);
    }
    jQuery(document).on('click','.burger-icon', function(){
        console.log('Open 1');
        if(jQuery(".popup-menu .dialog-widget-content").hasClass("menu-open") != true){
            console.log('Open 2');
            openMenu();
        }
    });
    jQuery(document).on('click','.close-modale-menu', function(){
        console.log('Close 1');
        if(jQuery(".popup-menu .dialog-widget-content").hasClass("menu-open") == true){
            console.log('Close 2');
            closeMenu();
        }
    });
})(jQuery);